module.exports = __webpack_public_path__ + "img/price transparency.3a524493.png";